// H3ScaleUp
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const H3 = styled.h3`
  letter-spacing: .18rem;
  padding: 0 1.5vw;
`;

function H3ScaleUp({ className = "", ...props }) {

  const classNames = [ "common-h-3-scale-up uk-text-times uk-text-center uk-text-uppercase uk-text-normal uk-text-dark-gray", className ].join(" ");
  return (
    <H3 className={ classNames } data-uk-scrollspy="cls:uk-animation-scale-up delay: 0; repeat: repeat;">
      { props.children }
    </H3>
  );
}

H3ScaleUp.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType ([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
};

export default H3ScaleUp;


// WEBPACK FOOTER //
// ./src/features/common/H3ScaleUp.js